export default __webpack_public_path__ + "files/media/arrow.react.27b035ec.svg";